import React, { useEffect, useState } from "react";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import backIcon from "../../assets/images/arrow_back_icon.svg";
import effortAnalysisIcon from "../../assets/images/effort-analysis-icon.png";
import { useDispatch, useSelector } from "react-redux";
import {
  capitalizeFirstLetter,
  formatAmount,
  getGenerateUrl,
  handleClickhdl,
  hardInteractionTypes,
} from "../../utils/constants";
import showAllIcon from "../../assets/images/show-all-icon.svg";
import directLineIcon from "../../assets/images/direct-meeting-blue.svg";
import virtualLineIcon from "../../assets/images/virtual-meeting-violet.svg";
import callLineIcon from "../../assets/images/phone-call-orange.svg";
import whatsappLineIcon from "../../assets/images/whatsapp-green.svg";
import emailLineIcon from "../../assets/images/email-icon-maroon.svg";
import salesProfile from "../../assets/images/salesProfile.png";
import interactionTitleIcons from "../../assets/images/interactions-title-icon.svg";
import phoneIconBlue from "../../assets/images/phone-icon-blue.svg";
import copySvg from "../../assets/images/copy.svg";

import { SetSelectedYear } from "../../redux/counterSlice";
import API from "../../services/api";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { differenceInDays, format, getDaysInMonth } from "date-fns";
import { formatDate } from "../../utils/dateFormat";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router";

function SalesInteractionHistory(props) {
  let { sales_person_id, sales_name, sales_list } = props.details;
  const dispatch = useDispatch();
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const navigate = useNavigate();

  // dispatch(SetSelectedYear(year));

  const currentDate = new Date();
  currentDate.setDate(1);
  currentDate.setHours(0, 0, 0, 0);
  const [selectedMonth, setSelectedMonth] = useState(props.selectedMonth || currentDate);
  const [salesPerson_id, setSalesPerson_id] = useState(sales_person_id);
  const [initialRender, setInitialRender] = useState(true);
  const [data, setData] = useState({});
  const [mainData, setMainData] = useState({});
  const [loader, setLoader] = useState(false);
  const [typeFilter, setTypeFilter] = useState(0);
  const [totalInteractions, setTotalInteractions] = useState([]);
  const [fullScreen, setFullScreen] = useState(false);
  const [listOfScrolls, setListofScrolls] = useState([]);
  const [availableDays, setAvailableDays] = useState([]);
  const [activeDateFilter, setActiveDateFilter] = useState(null);

  const now = new Date();
  let total_campaigns_count = 0,
    total_w2n_count = 0,
    total_camp_spent = 0,
    total_w2n_spent = 0,
    total_missed = 0,
    total_known = 0,
    total_unknown = 0;

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const fetchSalesInteractionHistoryData = async () => {
    try {
      setLoader(true);
      let result = await API({
        url: "/effort_analysis/sales_month_history",
        method: "POST",
        responseType: "json",
        data: {
          sales_person_id: salesPerson_id !== -1 ? salesPerson_id : undefined,
          month: selectedMonth,
        },
      });
      if (result.code === 200) {
        setData(result.data);
        setMainData(result.data);
        let tempResult = JSON.parse(JSON.stringify(result.data));
        if (Object.keys(tempResult).length) {
          setTotalInteractions(
            Object.keys(tempResult)
              .map((month) => tempResult[month].interactions)
              .flat()
          );
        } else {
          setTotalInteractions([]);
        }
        setTypeFilter(0);
      }
      setLoader(false);
      setInitialRender(false);
    } catch (error) {
      console.error("Error @ fetchBrandMonthInteractionsData", error);
    }
  };
  const handleMonthChange = (date) => {
    setSelectedMonth(date);
  };
  useEffect(() => {
    fetchSalesInteractionHistoryData();
  }, []);
  useEffect(() => {
    if (!initialRender) fetchSalesInteractionHistoryData();
  }, [selectedMonth, salesPerson_id]);
  const handleIntTypeChange = (type) => {
    let filtereddata = {};
    if (mainData && type) {
      Object.keys(mainData).map((month) => {
        let tempData = JSON.parse(JSON.stringify(mainData[month]));
        let filteredInteractions = tempData.interactions.filter(
          (item) => item.type === type
        );
        tempData.interactions = filteredInteractions;
        filtereddata[month] = tempData;
      });
      setData(JSON.parse(JSON.stringify(filtereddata)));
    }
    if (type === 0) {
      setData(mainData);
    }
    setTypeFilter(type);
  };
  const scrollToSection = (id) => {
    if (availableDays.includes(+id)) {
      document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      setActiveDateFilter(+id);
    }
  };
  useEffect(() => {
    let numberOfdays = getDaysInMonth(selectedMonth);
    setListofScrolls(
      Array.from({ length: numberOfdays }).map((_, index) => index + 1)
    );
  }, [selectedMonth]);
  let salesTitleNameDesg = salesUsersList.find(
    (item) => item.value === salesPerson_id
  )?.label;
  let match = salesTitleNameDesg.match(/^(.+?)\(\s*(.+?)\s*\)$/); // Match the pattern
  let SaleTitleName = "",
    SaleTitleDesg = "";
  if (match) {
    SaleTitleName = match[1];
    SaleTitleDesg = match[2];
  }

  useEffect(() => {
    let tempAvailable = [];
    Object.keys(data).map((date) => {
      let dateObj = new Date(date * 1000);
      let interactions = data[date].interactions;
      if (interactions.length) {
        tempAvailable.push(dateObj.getDate());
      }
    });
    setAvailableDays(tempAvailable);
  }, [data]);

  return (
    <SlDrawer
      open={Object.keys(props).length ? true : false}
      onSlRequestClose={handleRequestClose}
      noHeader={true}
      // contained={true}
      className="intrDrawer"
      style={{ "--size": "100vw" }}
    >
      <div class="effort-analyis">
        <div class={`effortbHeader noBg ${fullScreen ? "afterToggle" : ""}`}>
          <div class="titleRow">
            <div class="pageTitle">
              {salesUsersList?.length > 1 ? (
                <button
                  class="goBack-btn"
                  onClick={() => props.setShowEffort(false)}
                >
                  <img src={backIcon} alt="" /> <span>Go To Dashboard</span>
                </button>
              ) : null}
              <h3>
                <i class="icon">
                  <img src={effortAnalysisIcon} alt="" />
                </i>
                <span>Interaction History</span>
              </h3>
              <div class="view-navigate">
                <DatePicker
                  selected={selectedMonth}
                  onChange={handleMonthChange}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  className="dateChooser"
                />
              </div>
            </div>
            <div class="filters-more">
              {/* <button id="filters">
                <img src="assets/images/filters-icon.png" alt="" />
              </button> */}
              {sales_list?.length ? (
                <select
                  name="executive"
                  id="executive"
                  value={salesPerson_id}
                  onChange={(e) => {
                    setSalesPerson_id(+e.target.value);
                  }}
                >
                  {sales_list.map((item) => {
                    return <option value={item.value}>{item.label}</option>;
                  })}
                </select>
              ) : null}
            </div>
          </div>
        </div>

        {/* <!-- Effort Analysis - Calendar View --> */}
        <div class="view-container">
          <div class="viewHeader executiveHeader">
            <h5 class="headLabel"># Date</h5>
            <ul class="tabs">
              <li>
                <button
                  class={`btn-all ${typeFilter === 0 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(0);
                  }}
                >
                  <img src={showAllIcon} alt="" /> <span>Show All</span>
                </button>
              </li>{" "}
              <li>
                <button
                  class={`btn-dir-meet ${typeFilter === 1 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(1);
                  }}
                >
                  <img src={directLineIcon} alt="" />
                  <span>Direct Meeting</span>{" "}
                  <em>
                    {totalInteractions.filter((item) => item.type === 1).length}
                  </em>
                </button>
              </li>{" "}
              <li>
                <button
                  class={`btn-vir-meet ${typeFilter === 2 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(2);
                  }}
                >
                  <img src={virtualLineIcon} alt="" />
                  <span>Virtual Meeting</span>{" "}
                  <em>
                    {totalInteractions.filter((item) => item.type === 2).length}
                  </em>
                </button>
              </li>{" "}
              <li>
                <button
                  class={`btn-calls ${typeFilter === 3 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(3);
                  }}
                >
                  <img src={callLineIcon} alt="" />
                  <span>Calls</span>{" "}
                  <em>
                    {totalInteractions.filter((item) => item.type === 3).length}
                  </em>
                </button>
              </li>{" "}
              <li>
                <button
                  class={`btn-wa-chat ${typeFilter === 4 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(4);
                  }}
                >
                  <img src={whatsappLineIcon} alt="" />
                  <span>whatsApp</span>{" "}
                  <em>
                    {totalInteractions.filter((item) => item.type === 4).length}
                  </em>
                </button>
              </li>{" "}
              <li>
                <button
                  class={`btn-emailed ${typeFilter === 5 ? "active" : ""}`}
                  onClick={() => {
                    handleIntTypeChange(5);
                  }}
                >
                  <img src={emailLineIcon} alt="" />
                  <span>Emailed</span>{" "}
                  <em>
                    {totalInteractions.filter((item) => item.type === 5).length}
                  </em>
                </button>
              </li>{" "}
            </ul>
          </div>
          <div class="viewBody">
            <button
              id="changeView"
              class="mobileOnly"
              onClick={() => {
                setFullScreen(!fullScreen);
              }}
            >
              {!fullScreen ? "Full Screen View" : "Exit Full Screen View"}
            </button>
            {data && Object.keys(data)?.length && !loader ? (
              <>
                {Object.keys(data).map((date) => {
                  let dateObj = new Date(date * 1000);
                  let interactions = data[date].interactions;
                  let dateData = data[date];
                  let brand_ids = [
                    ...new Set(interactions.map((item) => item.brand_id)),
                  ];
                  let brandLogos = brand_ids.map((brand_id) => {
                    let intItem = interactions.find(
                      (item) => item.brand_id === brand_id
                    );
                    return {
                      brand_name: intItem?.brand_name,
                      logo_url: intItem?.logo_url,
                    };
                  });
                  if (dateData.effort) {
                    total_campaigns_count =
                      +total_campaigns_count +
                      +dateData.effort?.total_campaigns_count;
                    total_w2n_count =
                      +total_w2n_count + +dateData?.effort?.total_w2n_count;
                    total_camp_spent =
                      +total_camp_spent +
                      +dateData?.effort?.total_campaigns_spent;
                    total_w2n_spent =
                      +total_w2n_spent + +dateData?.effort?.total_w2n_spent;
                    total_missed =
                      +total_missed + +(dateData?.effort?.total_missed || 0);
                    total_known = +total_known + +dateData?.effort?.total_known;
                    total_unknown =
                      +total_unknown + +dateData?.effort?.total_unknown;
                  }
                  return (
                    <div class="day-interactions" id={dateObj.getDate()}>
                      <div class="dateNdall">
                        <div class="day">
                          <h6>{format(dateObj, "EEE")}</h6>
                          <h1>{dateObj.getDate()}</h1>
                          <h5>{format(dateObj, "MMMM")}</h5>
                        </div>
                        <h3 class="count">
                          Intrns: <span>{dateData?.interactions?.length}</span>
                        </h3>
                        <div class="stats competetive">
                          <h2 class="competetor-spent">
                            {formatAmount(
                              +dateData?.effort?.total_campaigns_spent
                            )}
                          </h2>
                          <h6>Competitor Spent</h6>
                        </div>
                        <div class="stats ours">
                          <h2 class="w2n-spent">
                            {formatAmount(+dateData?.effort?.total_w2n_spent)}
                          </h2>
                          <h6>W2N Spent</h6>
                        </div>
                        <span class="list">
                          {brandLogos.map((item) => {
                            return (
                              <img
                                src={
                                  item.logo_url ||
                                  getGenerateUrl(item.brand_name)
                                }
                                alt=""
                              />
                            );
                          })}
                        </span>
                      </div>
                      <div class="interactionHistory make-room">
                        {dateData?.interactions.map((item) => {
                          let mobileNumbers = [],
                            emails = [];
                          if (item.mobile1) mobileNumbers.push(item.mobile1);
                          if (item.mobile2) mobileNumbers.push(item.mobile2);
                          if (item.email1) emails.push(item.email1);
                          if (item.email2) emails.push(item.email2);
                          return (
                            <div
                              class={`interaction ${
                                item.type === 1
                                  ? "dir-meet"
                                  : item.type === 2
                                  ? "vir-meet"
                                  : item.type === 3
                                  ? "dir-call"
                                  : item.type === 4
                                  ? "wa-chat"
                                  : item.type === 5
                                  ? "e-mail"
                                  : ""
                              }`}
                            >
                              <div class="int-head">
                                <div class="name">
                                  <img src={interactionTitleIcons} alt="" />
                                  <h1>
                                    {capitalizeFirstLetter(item.name)}{" "}
                                    <span>
                                      {capitalizeFirstLetter(item.designation)}
                                    </span>
                                  </h1>
                                </div>
                                <div class={`meet-type`}>
                                  <img
                                    src={
                                      item.logo_url ||
                                      getGenerateUrl(item.brand_name)
                                    }
                                    alt=""
                                  />
                                  <p>
                                    {capitalizeFirstLetter(item.brand_name)}
                                  </p>
                                </div>
                              </div>
                              <div class="int-body">
                                <p>{item.description}</p>
                              </div>
                              <div class="int-footer">
                                <h5>
                                  <img src={phoneIconBlue} alt="" />{" "}
                                  <span>{mobileNumbers[0]}</span>
                                  <img
                                    src={copySvg}
                                    alt=""
                                    onClick={() =>
                                      handleClickhdl(mobileNumbers[0])
                                    }
                                  />
                                </h5>
                                <h6>{`${differenceInDays(
                                  now,
                                  new Date(item.date * 1000)
                                )} days ago | On ${formatDate(item.date)}`}</h6>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : !(data && Object.keys(data)?.length) && !loader ? (
              <div className="m-auto">
                <NoDataFound />
              </div>
            ) : (
              <div className="m-auto">
                <TableLoader />
              </div>
            )}
          </div>
          <div
            class={`viewFooter ${fullScreen ? "toggleHeight" : ""}`}
            id="executiveProfile"
          >
            <ul class="client-navigator">
              {listOfScrolls.map((item) => (
                <li
                  onClick={() => {
                    scrollToSection("" + item);
                  }}
                  className={`${activeDateFilter === item ? "active" : ""} ${
                    availableDays.includes(item) ? "available" : ""
                  }`}
                >
                  {item}
                </li>
              ))}
            </ul>
            <div class="execProfile">
              <div class="profile-pic">
                <img src={salesProfile} alt="" />
              </div>
              <div class="profile-details">
                <h1>
                  <div className="d-flex flex-col">
                    {capitalizeFirstLetter(SaleTitleName)}
                    <span>{SaleTitleDesg}</span>
                    <ul class="recentActivity">
                      <li class="direct-meeting">
                        <i class="icon">
                          {" "}
                          <span>
                            {
                              totalInteractions.filter(
                                (item) => item.type === 1
                              ).length
                            }
                          </span>
                        </i>
                      </li>
                      <li class="virtual-meeting">
                        <i class="icon">
                          <span>
                            {
                              totalInteractions.filter(
                                (item) => item.type === 2
                              ).length
                            }
                          </span>
                        </i>
                      </li>
                      <li class="phone-call">
                        <i class="icon">
                          <span>
                            {
                              totalInteractions.filter(
                                (item) => item.type === 3
                              ).length
                            }
                          </span>
                        </i>
                      </li>
                      <li class="whatsapp-chat">
                        <i class="icon">
                          <span>
                            {
                              totalInteractions.filter(
                                (item) => item.type === 4
                              ).length
                            }
                          </span>
                        </i>
                      </li>
                      <li class="email-chat">
                        <i class="icon">
                          <span>
                            {
                              totalInteractions.filter(
                                (item) => item.type === 5
                              ).length
                            }
                          </span>
                        </i>
                      </li>
                    </ul>
                  </div>
                  <i class="clients">{totalInteractions.filter(item => hardInteractionTypes.includes(item.type)).length}</i>
                </h1>
                {/* <div class="designation">
                  <p class="location">Hyderabad</p>
                </div> */}
              </div>
            </div>
            <div class="stats">
              <h2>{total_campaigns_count || 0}</h2>
              <h6>Competitor Campaigns</h6>
            </div>
            <div class="stats">
              <h2>{total_w2n_count || 0}</h2>
              <h6>W2N Campaigns</h6>
            </div>
            <div class="stats">
              <h2 class="competetor-spent">
                {formatAmount(total_camp_spent) || 0}
              </h2>
              <h6>Competitor Spent</h6>
            </div>
            <div class="stats">
              <h2 class="w2n-spent">{formatAmount(total_w2n_spent) || 0}</h2>
              <h6>W2N Spent</h6>
            </div>
            <div class="stats">
              <h2>{total_missed || 0}</h2>
              <h6>Missed</h6>
            </div>
            <div class="stats">
              <h2>{total_known || 0}</h2>
              <h6>Known</h6>
            </div>
            <div class="stats">
            <div className="percent">
              <h2>{total_unknown}</h2>
              <h5>{((total_unknown/(total_unknown + total_known) * 100) || 0).toFixed(1) }%</h5>
              </div>
              <h6>Unknown</h6>
            </div>
            <button class="history-btn" onClick={() => props.setShow(null)}>
              <img src={backIcon} alt="" />{" "}
              <span>Go back to Effort Analysis</span>
            </button>
          </div>
        </div>
      </div>
    </SlDrawer>
  );
}

export default SalesInteractionHistory;
